import { Page } from '@/core/architecture'

import { LotteryUserInfoTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * LotteryUserInfo Page
 * Implemented as a practical sample.
 */
export const LotteryUserInfo: Page = () => {
  const { state, actions } = useViewModel()

  return <LotteryUserInfoTemplate state={state} {...actions} />
}
